import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 全局loading动画
    loading: false,
    // 记录所有请求，用于切换页面时取消
    requests: [],
    userInfo: JSON.parse(localStorage.getItem('userInfo') || "{}"),
      oss: {}, //uni.getStorageSync('oss') || 
  },
  mutations: {
      oss(state, data) {
        // console.log(32,data)
        Object.assign(state.oss, data)
        // uni.setStorageSync('oss', state.oss)
      },
      userInfo(state, data) {
        console.log(32, data)
        if (data === null) {
          state.userInfo = {}
        } else {
          Object.assign(state.userInfo, data)
        }
        // uni.setStorageSync("imUid", state.userInfo.id)
        localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
        // if (data) {
        // 	store.commit("accountPush", data)
        // }
      },
    loadStatus(state, boolean) {
      state.loading = boolean
    },
    addRequest(state, string) {
      state.requests.push(string)
    }
  }, 
  actions: {
    oss(context, payload) {
      return new Promise((resolve, reject) => {
        if (context.state.oss.key) {
          return resolve(context.state.oss)
        }
        vm.$http("get tool/oss").then(res => {
          if (res.code !== 200) {
            return
          }
          context.commit("oss", res.data)
          resolve(context.state.oss)
        }).finally(res => {

        })
      })
    },
    user(context, payload) {
      return vm.$http('get user/info', {}).then(res => {
        if (res.code == 200) {
          context.commit("userInfo", res.data)
        } else {
          // this.$u.toast(res.msg)
        }
      })
    },
  },
})
